import { PagedResultDto } from '@umss/shared/data-access';
import { JobPosting } from '../models/job-posting.model';
import {
  ExperienceLevelEnum,
  PositionTypeEnum,
  ScopeOfPracticeEnum
} from '@umss/shared/utils';

export const JOB_POSTINGS_MOCK: JobPosting[] = [
  {
    id: 'job-001',
    facility: {
      id: 'fac-001',
      name: 'West Jordan Clinic',
      fullAddress: '123 Street, Midvale, UT 84555',
      distanceMiles: 4.8
    },
    postedAt: '2025-06-19T00:00:00Z',
    scopeOfPractice: ScopeOfPracticeEnum.Lpn,
    scopeOfPracticeDisplay: 'Licensed Practical Nurse',
    positionType: PositionTypeEnum.FullTime,
    positionTypeDisplay: 'Full-Time',
    experienceLevel: ExperienceLevelEnum.MidLevel,
    experienceLevelDisplay: 'Mid Level',
    priceRange: { minHourlyRate: 48, maxHourlyRate: 72 },
    interestedAt: '2025-06-20T00:00:00Z'
  },
  {
    id: 'job-002',
    facility: {
      id: 'fac-002',
      name: 'Sacred Heart',
      fullAddress: '456 Main Ave, Salt Lake City, UT 84101',
      distanceMiles: 14
    },
    postedAt: '2025-06-15T00:00:00Z',
    scopeOfPractice: ScopeOfPracticeEnum.Rn,
    scopeOfPracticeDisplay: 'Registered Nurse',
    positionType: PositionTypeEnum.FullTime,
    positionTypeDisplay: 'Full-Time',
    experienceLevel: ExperienceLevelEnum.EntryLevel,
    experienceLevelDisplay: 'Entry Level',
    priceRange: { minHourlyRate: 41, maxHourlyRate: 58 }
  },
  {
    id: 'job-003',
    facility: {
      id: 'fac-003',
      name: 'Mayo Clinic',
      fullAddress: '789 Clinic Blvd, Murray, UT 84123',
      distanceMiles: 22
    },
    postedAt: '2025-06-10T00:00:00Z',
    scopeOfPractice: ScopeOfPracticeEnum.Rn,
    scopeOfPracticeDisplay: 'Registered Nurse',
    positionType: PositionTypeEnum.PartTime,
    positionTypeDisplay: 'Part-Time',
    experienceLevel: ExperienceLevelEnum.Senior,
    experienceLevelDisplay: 'Senior',
    priceRange: { minHourlyRate: 53, maxHourlyRate: 77 }
  },
  {
    id: 'job-004',
    facility: {
      id: 'fac-004',
      name: 'Intermountain Medical Center',
      fullAddress: '5121 S Cottonwood St, Murray, UT 84107',
      distanceMiles: 8.3
    },
    postedAt: '2025-06-08T00:00:00Z',
    scopeOfPractice: ScopeOfPracticeEnum.Cna,
    scopeOfPracticeDisplay: 'Certified Nursing Assistant',
    positionType: PositionTypeEnum.FullTime,
    positionTypeDisplay: 'Full-Time',
    experienceLevel: ExperienceLevelEnum.MidLevel,
    experienceLevelDisplay: 'Mid Level',
    priceRange: { minHourlyRate: 46, maxHourlyRate: 63 }
  },
  {
    id: 'job-005',
    facility: {
      id: 'fac-005',
      name: 'University of Utah Hospital',
      fullAddress: '50 N Medical Dr, Salt Lake City, UT 84132',
      distanceMiles: 11.5
    },
    postedAt: '2025-06-01T00:00:00Z',
    scopeOfPractice: ScopeOfPracticeEnum.Lpn,
    scopeOfPracticeDisplay: 'Licensed Practical Nurse',
    positionType: PositionTypeEnum.Contract,
    positionTypeDisplay: 'Contract',
    experienceLevel: ExperienceLevelEnum.Senior,
    experienceLevelDisplay: 'Senior',
    priceRange: { minHourlyRate: 58, maxHourlyRate: 84 }
  }
];

export const JOB_POSTINGS_PAGED_MOCK: PagedResultDto<JobPosting> = {
  items: JOB_POSTINGS_MOCK,
  totalCount: JOB_POSTINGS_MOCK.length,
  pageNumber: 1,
  pageSize: 15,
  totalPages: 1,
  hasPreviousPage: false,
  hasNextPage: false
};
